import type { NskResponse } from "~/models/Api";
import type { DealEstimationOcrRequestCreated } from "~/models/DealEstimationOcrRequest";
import { postRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const create = async (
	file: File,
	dealId: number
): Promise<NskResponse<DealEstimationOcrRequestCreated>> => {
	const params = new FormData();
	params.append("file", file);
	return postRequest(
		generatePath("/deals/:deal_id/deal_estimation_ocr_requests", {
			deal_id: dealId
		}),
		params
	);
};
